import { render } from "./Fichatecnica.vue?vue&type=template&id=2b6ab2ab"
import script from "./Fichatecnica.vue?vue&type=script&lang=js"
export * from "./Fichatecnica.vue?vue&type=script&lang=js"

import "./Fichatecnica.vue?vue&type=style&index=0&id=2b6ab2ab&lang=css"

import exportComponent from "C:\\Users\\PC\\Documents\\vue.js\\marvel\\marvel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__